module.exports = __webpack_public_path__ + "img/falso-verdadero.91228c85.svg";